import React from 'react';
import Bootstrap from '../bootstrap';
import MicroComponent from '../common/MicroComponent';
import { inclusions } from '../data/inclusions';

const InclusionsList: React.FC = () => {
  return (
    <Bootstrap>
      <MicroComponent micro={{ sdkName: SERVICE_SDK_NAME, componentName: 'InclusionsList' }} inclusions={inclusions} />
    </Bootstrap>
  );
};

export default InclusionsList;
